module.exports = __webpack_public_path__ + "img/stock7.ec7db08b.png";